import { FieldErrors, useFormContext } from 'react-hook-form'
import { BefehlFormAuftrag, BefehlFormField } from '../Generic'
import { useTranslation } from 'react-i18next'
import { Input } from '../../form'
import { useMemo } from 'react'

export interface Auftrag2_10FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings: boolean
  errors?: FieldErrors
}

export default function Auftrag4_10Form({
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings,
  errors
}: Readonly<Auftrag2_10FormProps>) {
  const { control, formState } = useFormContext()
  const { t } = useTranslation('ui-befehle')

  const fieldErrors = useMemo(() => {
    return errors ?? formState.errors
  }, [errors, formState.errors])

  return (
    <BefehlFormAuftrag
      auftragKennung="4.10"
      fieldName="auftrag_4_10.enabled"
      readOnly={true}
      testId={testId}
    >
      <div className="@container">
        <div
          className="flex flex-col @[400px]:flex-row items-baseline gap-1"
          data-testid={`${testId}-outer-div`}
        >
          <span data-testid={`${testId}-text`}>
            {t('auftraege.4_10.before_input')}
          </span>
          <div className="flex flex-col flex-grow max-w-xs">
            <BefehlFormField
              name={'auftrag_4_10.field_4_11.eindeutigeKennung'}
              control={control}
              label={t('auftraege.4_10.input_label_field')}
              readOnly={readOnly}
              activateEmptyWarning={activateEmptyFieldWarnings}
              data-testid={`${testId}-eindeutige-kennung`}
              render={({ field, isFieldEmpty, isDisabled }) => (
                <Input
                  {...field}
                  label={t('auftraege.4_10.input_label_field')}
                  errors={fieldErrors}
                  className="flex-grow"
                  activateEmptyWarning={
                    activateEmptyFieldWarnings && isFieldEmpty && !isDisabled
                  }
                  data-testid={`${testId}-eindeutige-kennung-inner`}
                  disabled={readOnly}
                />
              )}
            ></BefehlFormField>
            <span data-testid={`${testId}-eindeutige-kennung-label`}>
              {t('auftraege.4_10.input_label')}
            </span>
          </div>
          <span data-testid={`${testId}-text-wird-widerrufen`}>
            {t('auftraege.4_10.after_input')}
          </span>
        </div>
      </div>
    </BefehlFormAuftrag>
  )
}
